import React, { useState, useEffect } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import Footer from "../Component/Footer";
import ProfileNavbar from "../Component/ProfileNavbar";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import axios from "axios";
import defaultuser from "../Component/img/user.png"; // Default image if no profile image is available
import { Link } from 'react-router-dom';

const ConnectionPending = () => {
  const [pendingConnections, setPendingConnections] = useState([]);
  const user_id = localStorage.getItem("visitor_id"); // Get the visitor ID from localStorage

  useEffect(() => {
    // Fetch pending connections from the API
    const fetchPendingConnections = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/pending-connections`, {
          params: { user_id }, // Sending the user_id as a query parameter
        });
  
        if (response.data.pendingConnections) {
          setPendingConnections(response.data.pendingConnections);
        }
      } catch (error) {
        // Only log the error if the status code is not 409
        if (error.response && error.response.status !== 409) {
          console.error("Error fetching pending connections:", error);
        }
      }
    };
  
    fetchPendingConnections();
  }, [user_id]);

  // Function to handle the accept button click
  const handleAccept = async (sender_id) => {
    try {
      // Log the data that will be sent in the POST request
      console.log("Sending data to API:", {
        sender_id,
        receiver_id: user_id, // The current user_id is the receiver
      });
  
      const response = await axios.post(`${BASE_URL}/update-connection-status`, {
        sender_id,
        receiver_id: user_id, // The current user_id is the receiver
      });
  
      if (response.status === 200) {
        alert("Connection accepted!");
        // Optionally refresh the list of pending connections or update UI here
        setPendingConnections(prev => prev.filter(user => user.id !== sender_id));
      }
    } catch (error) {
      console.error("Error accepting connection:", error);
      // You can also show an error message here
      alert("Failed to accept the connection.");
    }
  };
  

  return (
    <>
      <NavbarVisitor />
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <ProfileNavbar />
            </div>
            <div className="col-md-9">
              <div className="bg-salt mt-3 p-2 py-3 mb-3 text-start">
                <h2 className="text-start hedng">Pending Connections</h2>

                <div className="d-flex p-2">
                  <div className="reqbtna">
                    <Link to="/my-connection">Send Request</Link>
                  </div>
                  <div className="reqbtna reqbtnaActive">
                    <Link to="/connection-pending">Pending Request</Link>
                  </div>
                </div>

                <div className="row">
                  {pendingConnections.length > 0 ? (
                    pendingConnections.map((user) => (
                      <div key={user.id} className="col-md-6 mb-2">
                        <div className="d-flex justify-content-between align-items-center bg-white p-2">
                          <div className="d-flex">
                            <div>
                              <img
                                src={
                                  user.profile_image
                                    ? `${IMAGE_URL}/${user.profile_image}`
                                    : defaultuser
                                }
                                className="img-fluid maxconimg"
                                alt="Profile"
                              />
                            </div>
                            <div className="ms-3">
                              <div className="oksa">
                                <strong>{user.id}</strong>
                              </div>
                              <div className="oksa">{user.designation}</div>
                              <div className="oksa text-muted">
                                {user.city}, {user.state}, {user.country}
                              </div>
                            </div>
                          </div>
                          <div className="ms-3">
                            <button
                              className="btnflo1 bg-gradient-info mgrtu"
                              onClick={() => handleAccept(user.id)} // Call handleAccept when the button is clicked
                            >
                              Accept
                            </button>

                            <button className="btnflo1 bg-gradient-primary">
                              Decline
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>No pending connections found</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ConnectionPending;
